/*
* Code for handling WFM lead forms being pulled into a page via ajax/panelizr
*
* NOTE: Everything should now be self-contained to this code file and completely separate from panelizr code.
*       i.e. panelizr doesn't know or care if it is loading in a lead form, it just does ajax loading of some content
*       and we set it to call the leadFormInit callback for any lead forms. 
*       THIS CODE, however, will only work for WFM forms pulled in via panelizr and expects certain parent elements, etc.
*
* REQUIREJS NOTE: Setting a global var like this is pretty crappy, we shouldn't do this much.
*/
define('core/wfm/leadforms',["jquery", "core/global/compensatrs", "core/ef_plugins/spinnerhelper", "libs/jquery.cookie"], function ($, compensatr) {
    var EFTOURS = window.EFTOURS || {};

    return EFTOURS.leadforms = (function () {
        var isCtaByForm = {};
        var leadFormSpinner = null;

        // helper to get the form item name for analytics
        function getFormName($form) {
            return $form.find('#leadFormName').val();
        }

        function scrollBackToPanel($panelTop) {
            if ($panelTop.length > 0) {
                window.scrollTo(0, $panelTop.offset().top + -20);
            }
        }

        function getUpdateTarget($form) {
            var formName = getFormName($form);
            var updateTargetClass = isCtaByForm[formName] ? '.cta-body' : '.panel-body';

            return '#' + $form.closest(updateTargetClass).attr("id");
        }

        return {
            // Callback for initial loading of lead form into panelizr *******************
            leadFormInit: function ($panel, response, status, xhr, cta) {
                var $form = $panel.find('form');
                var formName = getFormName($form);
                isCtaByForm[formName] = cta;

                var updateTarget = getUpdateTarget($form);

                $form.attr('data-ajax-update', updateTarget);
                compensatr.handleTelLinks();
            },

            // Callbacks for lead form unobtrusive ajax submission *******************
            // OnBegin 
            leadFormBegin: function (xhr) {
                var $form = $(this);

                // scroll to the top of the panel if not cta
                if (isCtaByForm[getFormName($form)] === false) {
                    $panelTop = $('#' + $form.closest('.panel').attr('id') + ' .panel-header');
                    scrollBackToPanel($panelTop);
                }

                // disable re-submission of form
                $form.find(":submit").attr("disabled", "disabled");

                if (leadFormSpinner) {
                    leadFormSpinner = leadFormSpinner.destroy();
                }
                // start the spinner
                leadFormSpinner = $form.closest('.panel').spinnerhelper({ 'type': 'overlay', 'delay': 100 }).data('plugin_spinnerhelper');

            },

            // OnComplete (always fires whether there was an error or not)
            leadFormComplete: function (xhr, status) {
                var formId = this.getAttribute('id');
                var formAction = this.getAttribute('action');
                var $form = $('#' + formId + '[action="' + formAction + '"]');
                var updateTarget = getUpdateTarget($form)

                // stop the spinner
                if (leadFormSpinner) {
                    leadFormSpinner = leadFormSpinner.destroy();
                }

                $form.attr('data-ajax-update', updateTarget);
            },

            // OnSuccess (fires only if load was successful)
            leadFormSuccess: function (data, status, xhr) {
                var $form = $(this);
                var formName = getFormName($form);

                // Get the root domain, tge part of the domain name before second-to-last dot. Typically ".eftours.com." That way, the cookie works across subdomains.
                // Given www.eftours.com, eftours.com, landing.eftours.com, or blah.foo.bar.eftours.com, the root domain should be .eftours.com.
                var domain = document.domain.toString();
                var domainPieces = domain.split('.');
                var rootDomain = "." + domainPieces[domainPieces.length - 2] + "." + domainPieces[domainPieces.length - 1];

                if ($('.form-success').length > 0) {
                    dataLayer.push({ 'event': 'load', 'context': formName + ' Confirmation', 'pageType': 'virtual' });
                    // Sets cookie to prevent disruptr -- this cookie and logic is shared with scripts in liveball
                    // For compatibility with Liveball, we'll temporarily set raw = true.
                    // This prevents jQuery cookie from URI encoding the cookie value.
                    $.cookie.raw = true;
                    var cookieString = "Count=3&Disable=true";
                    $.cookie('EFFEDCK', cookieString, {
                        expires: 180,
                        path: '/',
                        domain: rootDomain
                    });
                    // Return jQuery cookie to raw = false, in case other scripts use it.
                    $.cookie.raw = false;
                }
            },

            // OnFailure (fires if load failed)
            leadFormFailure: function (xhr, status, error) {
                var $form = $(this);
                var formName = getFormName($form);

                dataLayer.push({ 'event': 'load', 'context': formName + ' Error', 'pageType': 'virtual' });
            }
        };
    }());
});
